export default function EmptyState({ icon, title, description, actionLabel, onAction, actionLink }) {
    return (
        <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
            {icon && (
                <i className={`${icon} text-6xl text-border mb-4`}></i>
            )}
            {title && (
                <h3 className="text-xl font-semibold text-foreground mb-2">{title}</h3>
            )}
            {description && (
                <p className="text-muted-foreground mb-6 max-w-md">{description}</p>
            )}
            {actionLabel && actionLink && (
                <Link
                    to={actionLink}
                    className="px-6 py-2.5 bg-primary text-white rounded-lg font-medium hover:brightness-110 transition-all whitespace-nowrap"
                >
                    {actionLabel}
                </Link>
            )}
            {actionLabel && onAction && !actionLink && (
                <button
                    onClick={onAction}
                    className="px-6 py-2.5 bg-primary text-white rounded-lg font-medium hover:brightness-110 transition-all whitespace-nowrap"
                >
                    {actionLabel}
                </button>
            )}
        </div>
    );
}
